const request = {
    message_rate_limited: 'Muitas mensagens foram enviadas a este destinatário. Tente novamente mais tarde.',
    invalid_input: 'Entrada inválida. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    range_not_satisfiable: 'Intervalo não satisfatório.',
    feature_not_supported: 'Este recurso não é suportado no ambiente atual.',
    rate_limited: 'Muitas solicitações. Tente novamente mais tarde.',
};
export default Object.freeze(request);
